import { validateKlarnaOrigin } from '../validateKlarnaOrigin';
export const ignoreNonSDKErrors = (event) => {
    let shouldDropError = true;
    event.exception?.values?.forEach(({ stacktrace }) => {
        stacktrace?.frames?.forEach(({ filename }) => {
            shouldDropError = !validateKlarnaOrigin(filename);
        });
    });
    if (shouldDropError) {
        return null;
    }
    return event;
};
